import { call, put } from 'redux-saga/effects';
import { fetchUser, fetchUsersByIds } from '../../containers/AdminPanel/features/users/usersAPI';
import { upsertUsers } from '@/common/slice/userList';

export function* hydrateUsers(userIds) {
  const ids = Array.isArray(userIds) ? userIds.filter((id) => id != null) : [];
  if (ids.length === 0) return;

  const unique = Array.from(new Set(ids));

  const userMap = {};

  // One batched request for the whole page; the per-user profile call is only a
  // fallback for ids the list endpoint does not return.
  try {
    const response = yield call(fetchUsersByIds, unique);
    const users = (response && (response.users || response.Users)) || [];
    users.forEach((user) => {
      const id = user && (user.id ?? user.user_id);
      if (id != null) userMap[id] = user;
    });
  } catch (_) {
  }

  for (const id of unique) {
    if (userMap[id]) continue;
    try {
      const response = yield call(fetchUser, { userId: id });
      if (response && !response.error && !response.Error) {
        userMap[id] = response;
      }
    } catch (_) {
    }
  }

  if (Object.keys(userMap).length > 0) {
    yield put(upsertUsers(userMap));
  }
}
